export const userDefinedTypes = [
  "parts",
  "features",
  "translations",
  "primers"
];
export const userDefinedTypesMap = userDefinedTypes.reduce(function(nextVal, key) {
  nextVal[key] = key;
  return nextVal;
}, {});
export const derivedDataTypes = ["cutsites", "orfs"];
export const derivedDataTypesMap = derivedDataTypes.reduce(function(nextVal, key) {
  nextVal[key] = key;
  return nextVal;
}, {});
export function getSingular(type) {
  return type.slice(0, -1);
}
export const allTypes = [
  ...userDefinedTypes,
  ...derivedDataTypes,
  "restriction_sites"
];
